import { Grid } from '@ltvco/refresh-lib/theme';
import { type ReactNode } from 'react';

import { PromoCtaButton, PromoFeatureCard } from './PromoFeatureCard';

export type ExploreLocalCrimePromoCardProps = {
  isCompactLayout: boolean;
  mdColumns: number;
  illustration: ReactNode;
  onCheckIncidents: () => void;
};

export function ExploreLocalCrimePromoCard({
  isCompactLayout,
  mdColumns,
  illustration,
  onCheckIncidents,
}: ExploreLocalCrimePromoCardProps) {
  const ctaSxCompact = isCompactLayout ? { flexShrink: 0 as const } : undefined;

  return (
    <Grid
      size={{ xs: 12, md: mdColumns }}
      sx={{ display: 'flex', alignItems: 'stretch' }}
    >
      <PromoFeatureCard
        isCompactLayout={isCompactLayout}
        id="crime-incidents-section"
        illustration={illustration}
        title="Explore Local Crime"
        body="Explore nearby crime trends to better understand safety in any area."
        cta={
          <PromoCtaButton
            variant="contained"
            color="primary"
            onClick={onCheckIncidents}
            sx={ctaSxCompact}
          >
            Check Incidents
          </PromoCtaButton>
        }
      />
    </Grid>
  );
}
